export default __webpack_public_path__ + "static/media/keranjang.1f6462be.svg";